(() => {
  const label = document.currentScript?.dataset.whatsappLabel;
  const prepareLink = () => {
    const link = document.getElementById('whatsapp-link');
    if (!link) return;
    link.href = 'https://wa.me/972549039389';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    if (label) link.setAttribute('aria-label', label);
  };

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element && event.target.closest('#whatsapp-link');
    if (!link) return;
    prepareLink();
    event.stopImmediatePropagation();
  }, true);

  prepareLink();
  new MutationObserver(prepareLink).observe(document.body, { childList: true, subtree: true });
})();
